function GradientBorderBox({ children, className, height }) {
    const heightClass = height ? height : 'h-full'

    return (
        <div className={className}>
            <div
                className={`text-xl ${heightClass}  w-full shadow-lg p-[2px] rounded olm-gradient hover:bg-none   text-white font-semibold text-center`}>
                <div
                    className={`flex ${heightClass} justify-center items-center bg-white rounded text-secondary`}>
                    {children}
                </div>
            </div>
        </div>
    )
}

export default GradientBorderBox
